import { CtepBrandID } from "@/utils/ctep/ctep-brands";

export interface ICtepDefaultBankForPaymentType {
	BankTypeID:number;
	PaymentType:CtepBrandID;
}

export interface IBankBookingFavorite {
	ID:number;
	Name:string;
	TypeID:number;
	Kind:number;
	LedgerAccountCode:string;
	Info:string;
}

export const DEFAULT_SALE_TYPE_IDS_FOR_BOOKINGS = [1, 2, 9];

export enum TerminalID {
	Bancontact = "BANCONTACT",
	WorldlinePayconiq = "WORLDLINE_PAYCONIQ",
	WorldlineVisa = "WORLDLINE_VISA",
	WorldlineMastercard = "WORLDLINE_MASTERCARD",
	Edenred = "EDENRED",
	Pluxee = "PLUXEE",
	Monizze = "MONIZZE"
}

export const DEFAULT_TERMINAL_TRANSFER_LEDGER_ACCOUNT_CODE = "580000";
export const DEFAULT_TERMINAL_COST_LEDGER_ACCOUNT_CODE = "655301";

export interface ITerminalBooking {
	Terminal:TerminalID;
	BankTypeID:number;
	CostLedgerAccountCode:string;
}

export function getDefaultTerminalBookings():ITerminalBooking[] {
	return [
		{
			Terminal: TerminalID.Bancontact, BankTypeID: 1, CostLedgerAccountCode: ""
		},
		{
			Terminal: TerminalID.WorldlinePayconiq, BankTypeID: 1, CostLedgerAccountCode: DEFAULT_TERMINAL_COST_LEDGER_ACCOUNT_CODE
		},
		{
			Terminal: TerminalID.WorldlineVisa, BankTypeID: 2, CostLedgerAccountCode: DEFAULT_TERMINAL_COST_LEDGER_ACCOUNT_CODE
		},
		{
			Terminal: TerminalID.WorldlineMastercard, BankTypeID: 3, CostLedgerAccountCode: DEFAULT_TERMINAL_COST_LEDGER_ACCOUNT_CODE
		},
		{
			Terminal: TerminalID.Edenred, BankTypeID: 4, CostLedgerAccountCode: DEFAULT_TERMINAL_COST_LEDGER_ACCOUNT_CODE
		},
		{
			Terminal: TerminalID.Pluxee, BankTypeID: 5, CostLedgerAccountCode: DEFAULT_TERMINAL_COST_LEDGER_ACCOUNT_CODE
		},
		{
			Terminal: TerminalID.Monizze, BankTypeID: 6, CostLedgerAccountCode: DEFAULT_TERMINAL_COST_LEDGER_ACCOUNT_CODE
		}
	];
}

export const TERMINALS_WITH_COST_BOOKING = [
	TerminalID.WorldlinePayconiq,
	TerminalID.WorldlineVisa,
	TerminalID.WorldlineMastercard,
	TerminalID.Edenred,
	TerminalID.Pluxee,
	TerminalID.Monizze
];

export class BankConfig {
	CtepDefaultBankForPaymentTypes:ICtepDefaultBankForPaymentType[] = [];
	ProcessTerminalTransactions:boolean = true;
	TerminalBookings:ITerminalBooking[] = getDefaultTerminalBookings();
	TerminalTransferLedgerAccountCode:string = DEFAULT_TERMINAL_TRANSFER_LEDGER_ACCOUNT_CODE;
	Favorites:IBankBookingFavorite[] = [];
	SaleTypeIDsForBookings:number[] = [...DEFAULT_SALE_TYPE_IDS_FOR_BOOKINGS];

	public constructor(data:any){
		this.CtepDefaultBankForPaymentTypes = [...(data.CtepDefaultBankForPaymentTypes || [])];
		this.ProcessTerminalTransactions = data.ProcessTerminalTransactions ?? true;
		this.TerminalBookings = getDefaultTerminalBookings().map(d=>{
			let stored = (data.TerminalBookings || []).find((t:ITerminalBooking)=>t.Terminal == d.Terminal);
			if (!stored) {
				return d;
			}
			return {
				Terminal: d.Terminal,
				BankTypeID: stored.BankTypeID || 0,
				CostLedgerAccountCode: stored.CostLedgerAccountCode || ""
			};
		});
		this.TerminalTransferLedgerAccountCode = data.TerminalTransferLedgerAccountCode || DEFAULT_TERMINAL_TRANSFER_LEDGER_ACCOUNT_CODE;
		this.Favorites = [...(data.Favorites || [])];
		this.SaleTypeIDsForBookings = [...(data.SaleTypeIDsForBookings || DEFAULT_SALE_TYPE_IDS_FOR_BOOKINGS)];
	}

	public getJSON(){
		return {
			CtepDefaultBankForPaymentTypes: [...this.CtepDefaultBankForPaymentTypes],
			ProcessTerminalTransactions: this.ProcessTerminalTransactions,
			TerminalBookings: this.TerminalBookings.map(t=>{
				return {...t};
			}),
			TerminalTransferLedgerAccountCode: this.TerminalTransferLedgerAccountCode,
			Favorites: [...this.Favorites],
			SaleTypeIDsForBookings: [...this.SaleTypeIDsForBookings]
		};
	}

	public getTerminalBooking(terminal:TerminalID):ITerminalBooking | undefined {
		return this.TerminalBookings.find(t=>t.Terminal == terminal);
	}

	public isSaleTypeAllowedForBookings(typeID:number):boolean {
		return this.SaleTypeIDsForBookings.indexOf(typeID) != -1;
	}

	public getBankIdByCtepBrandID(brandId:string):number{
		for (let setting of this.CtepDefaultBankForPaymentTypes){
			if (setting.PaymentType == brandId) {
				return setting.BankTypeID || 0;
			}
		}
		return 0;
	}
}
